// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header.css */

.header {
  background-color: #f8fafc;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e2e8f0;
}
.user-section {
  font-weight: 500;
}
.toggle-btn {
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #616262;
}


/* dashboard.css */
.dashboard-container {
  display: flex;
  height: 100vh;
  background-color: #f9fafb;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.main-content {
  margin-left: 220px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s ease;
}

.main-content.collapsed {
  margin-left: 60px;
}

.dashboard-content {
  padding: 2rem;
  flex: 1 1;
}

.dashboard-title {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: #1f2937;
}

.cards {
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.card {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  flex: 1 1;
  min-width: 200px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.card-icon {
  font-size: 2.2rem;
  color: #3b82f6;
  margin-bottom: 0.75rem;
}

.card-icon.success {
  color: #10b981;
}

.card-icon.warning {
  color: #f59e0b;
}

.card h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #374151;
}

.card p {
  font-size: 1.4rem;
  font-weight: bold;
  color: #111827;
}

/* sidebar.css */



.sidebar {
  width: 250px;
  background-color: #f8fafc;
  height: 100vh;
  padding: 1rem;
  position: fixed;
  border-right: 1px solid #e2e8f0;
  transition: all 0.3s ease;
  overflow: hidden;
}

.logo {
  font-size: 1.5rem;
  margin-bottom: 2rem;

}
.nav-links {
  list-style: none;
  padding: 0;
}
.sidebar-collapsed {
  width: 70px;
}

.nav-links li {
  display: flex;
  align-items: center;
  font-size: 18px;
  line-height: 2.5;
}

.nav-links a {
  color: rgb(43, 42, 42);
  text-decoration: none;
  
}


.nav-links a:hover{
  color: rgb(25, 161, 129);
}`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;;AAGA,kBAAkB;AAClB;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;;;;AAIhB;EACE,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;AAErB;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;;AAEvB;;;AAGA;EACE,wBAAwB;AAC1B","sourcesContent":["/* header.css */\r\n\r\n.header {\r\n  background-color: #f8fafc;\r\n  padding: 1rem 2rem;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  border-bottom: 1px solid #e2e8f0;\r\n}\r\n.user-section {\r\n  font-weight: 500;\r\n}\r\n.toggle-btn {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n  color: #616262;\r\n}\r\n\r\n\r\n/* dashboard.css */\r\n.dashboard-container {\r\n  display: flex;\r\n  height: 100vh;\r\n  background-color: #f9fafb;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.main-content {\r\n  margin-left: 220px;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: margin-left 0.3s ease;\r\n}\r\n\r\n.main-content.collapsed {\r\n  margin-left: 60px;\r\n}\r\n\r\n.dashboard-content {\r\n  padding: 2rem;\r\n  flex: 1;\r\n}\r\n\r\n.dashboard-title {\r\n  font-size: 1.8rem;\r\n  font-weight: 600;\r\n  margin-bottom: 1.5rem;\r\n  color: #1f2937;\r\n}\r\n\r\n.cards {\r\n  display: flex;\r\n  gap: 1.5rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.card {\r\n  background: white;\r\n  padding: 1.5rem;\r\n  border-radius: 12px;\r\n  flex: 1;\r\n  min-width: 200px;\r\n  text-align: center;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.card:hover {\r\n  transform: translateY(-4px);\r\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.card-icon {\r\n  font-size: 2.2rem;\r\n  color: #3b82f6;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.card-icon.success {\r\n  color: #10b981;\r\n}\r\n\r\n.card-icon.warning {\r\n  color: #f59e0b;\r\n}\r\n\r\n.card h3 {\r\n  font-size: 1.1rem;\r\n  margin-bottom: 0.5rem;\r\n  color: #374151;\r\n}\r\n\r\n.card p {\r\n  font-size: 1.4rem;\r\n  font-weight: bold;\r\n  color: #111827;\r\n}\r\n\r\n/* sidebar.css */\r\n\r\n\r\n\r\n.sidebar {\r\n  width: 250px;\r\n  background-color: #f8fafc;\r\n  height: 100vh;\r\n  padding: 1rem;\r\n  position: fixed;\r\n  border-right: 1px solid #e2e8f0;\r\n  transition: all 0.3s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n.logo {\r\n  font-size: 1.5rem;\r\n  margin-bottom: 2rem;\r\n\r\n}\r\n.nav-links {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n.sidebar-collapsed {\r\n  width: 70px;\r\n}\r\n\r\n.nav-links li {\r\n  display: flex;\r\n  align-items: center;\r\n  font-size: 18px;\r\n  line-height: 2.5;\r\n}\r\n\r\n.nav-links a {\r\n  color: rgb(43, 42, 42);\r\n  text-decoration: none;\r\n  \r\n}\r\n\r\n\r\n.nav-links a:hover{\r\n  color: rgb(25, 161, 129);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
